import { HumanName } from '@medplum/fhirtypes';

/**
 * Initials for an avatar, from a structured `HumanName`.
 *
 * First-of-given plus first-of-family, so a middle name never displaces the
 * surname.
 *
 * Note `provider-app`'s `IdentityRow.getInitials` is deliberately a *different*
 * function, not a duplicate to be collapsed into this one: it takes an
 * already-formatted display string and returns the first letters of its first
 * two words, so "Mary Jane Watson" gives "MJ" there and "MW" here. They also
 * disagree on the empty case ('?' there, '' here). Use this one wherever the
 * structured name is available.
 */
export function getInitialsFromHumanName(name?: HumanName): string {
  const given = name?.given?.[0]?.[0] ?? '';
  const family = name?.family?.[0] ?? '';
  return `${given}${family}`.toUpperCase();
}

/**
 * "Given Family" — the display string the queue avatars are keyed on.
 *
 * First given name only, so a middle name never pushes the surname off a
 * 42px row. Empty when the name is absent.
 */
export function formatGivenFamilyName(name?: HumanName): string {
  return `${name?.given?.[0] ?? ''} ${name?.family ?? ''}`.trim();
}
